import React, { useState, useEffect } from "react";
import "@/styles/Nin9rs/Nin9rs.css";
import PoweredByNextcaddyLogo from "@/svg/logos/PoweredByNextcaddyLogo";
import Nin9rsBackgroundSvg from "@/components/Nin9rs/Nin9rsBackgroundSvg";
import Nin9rsLogo from "@/svg/logos/Nin9rsLogo";
import IglLogo from "@/svg/logos/IglLogo";
import axios from "axios";
import Spinner from "@/svg/Spinner";
import Nin9rsConfrontation from "@/components/Nin9rs/Nin9rsConfrontation";
// @ts-ignore
import { initSocketEvents } from "@/util/socket";
import { handleNin9rsSocketResponse } from "@/methods/nin9rs_methods";
let competitionsId = [];
let firstColumnConfrontations = null;
let env = null;
let socketChannel = null;
const Nin9rs = () => {
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [data, setData] = useState(null);
    if (data &&
        data[0] !== undefined &&
        data[0] !== null &&
        data[0].competitions &&
        Array.isArray(data[0].competitions)) {
        firstColumnConfrontations = data[0].competitions.length;
        data[0].competitions.map(({ competition }) => competitionsId.push(competition.id));
        if (data[0].competitions[0]) {
            env = data[0].competitions[0].env;
            socketChannel = data[0].competitions[0].socketChannel;
        }
    }
    let previousColumnConfrontations = null;
    // Cargar datos iniciales
    useEffect(() => {
        setLoading(true);
        axios.get(`/nin9rs/data`)
            .then((response) => {
            if (response.data.error) {
                setErrorMessage("Ha ocurrido un error desconocido");
            }
            else {
                setData(response.data);
            }
        })
            .catch(() => {
            setErrorMessage("Ha ocurrido un error desconocido");
        })
            .finally(() => setLoading(false));
    }, []);
    useEffect(() => {
        if (!socketChannel) {
            return;
        }
        const unsubscribeFromSocket = initSocketEvents({
            channel: socketChannel,
            action: (response) => handleNin9rsSocketResponse(response, competitionsId, env, setData)
        });
        return () => {
            unsubscribeFromSocket();
        };
    }, [socketChannel]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Nin9rsBackgroundSvg, null),
        React.createElement("div", { className: "container" },
            React.createElement("nav", null,
                React.createElement("label", { className: "navTitle" }, "NIN9R GAMES 2025"),
                React.createElement("div", { className: "navLogosContainer" },
                    React.createElement("img", { src: "/img/frontend/nin9rs/pga_spain_logo.png", className: "pgaLogo", alt: "PGA Spain Logo" }),
                    React.createElement(IglLogo, null),
                    React.createElement(Nin9rsLogo, null),
                    React.createElement(PoweredByNextcaddyLogo, null))),
            React.createElement("div", { className: "content" }, loading ?
                React.createElement(Spinner, null)
                :
                    React.createElement(React.Fragment, null, null !== data &&
                        data.map(({ groupingName, competitions }) => {
                            const columnConfrontations = null === previousColumnConfrontations ? firstColumnConfrontations : previousColumnConfrontations / 2;
                            previousColumnConfrontations = columnConfrontations;
                            const confrontationsLeft = null === columnConfrontations ? 0 : columnConfrontations - competitions.length;
                            return React.createElement("div", { key: groupingName, className: "column" },
                                React.createElement("div", { className: "columnLabel" },
                                    React.createElement("label", null, groupingName)),
                                competitions.map(({ competition, teams }) => {
                                    return (null !== teams && Object.keys(teams).length > 0) &&
                                        React.createElement(Nin9rsConfrontation, { key: competition.id, competitionId: competition.id, teams: teams });
                                }),
                                Array.from({ length: confrontationsLeft }).map((_, i) => (React.createElement(Nin9rsConfrontation, { key: i, teams: [] }))));
                        }))))));
};
export default Nin9rs;
